import request from '@/utils/request'

export function fetchList(params) {
    return request({
        url: '/branch/list',
        method: 'get',
        params: params
    })
}

export function createBranch(data) {
    return request({
        url: '/branch/create',
        method: 'post',
        data: data
    })
}

export function updateBranch(id, data) {
    return request({
        url: '/branch/update/' + id,
        method: 'post',
        data: data
    })
}

export function updateStatus(id, params) {
    return request({
        url: '/branch/updateStatus/' + id,
        method: 'post',
        params: params
    })
}

export function deleteBranch(params) {
    return request({
        url: '/branch/delete',
        method: 'post',
        params: params
    })
}

export function fetchAllBranchList() {
    return request({
        url: '/branch/listAll',
        method: 'get'
    })
}

